module.exports = __webpack_public_path__ + "media/illustrations/assignment_templates_self-8dceec79.svg";